angular.module("avant.customer_applications.controllers").controller "CustomerApplicationsCongratulationsCtrl", [
  "$controller"
  "$scope"
  "ApplicationService"
  "CustomerApplicationService"
  (
    $controller
    $scope
    ApplicationService
    CustomerApplicationService
  ) ->

    $scope.page = "congratulations"
    $scope.stageFromState = () => $scope.page

    # These assets are Avant Card specific but the Congratulations stage is an Avant card specific stage so I didn't
    # see the need to create a generic Congratulations controller and an Avant card specific override. If we get to 
    # a point where other partners/products want to implement their own Congratulations stage, that's when we should
    # refactor this to a generic controller.

    $scope.appStoreLogo     = require('@amount/frontend-styles/src/images/partners/avant/logo/app-store.png')
    $scope.appStoreLogo2x   = require('@amount/frontend-styles/src/images/partners/avant/logo/app-store@2x.png')
    $scope.creditCardLogo   = require('@amount/frontend-styles/src/images/partners/avant/logo/credit-card.png')
    $scope.creditCardLogo2x = require('@amount/frontend-styles/src/images/partners/avant/logo/credit-card@2x.png')
    $scope.googlePlayLogo   = require('@amount/frontend-styles/src/images/partners/avant/logo/google-play.png')
    $scope.googlePlayLogo2x = require('@amount/frontend-styles/src/images/partners/avant/logo/google-play@2x.png')
    $scope.phoneLogo        = require('@amount/frontend-styles/src/images/partners/avant/logo/phone.png')
    $scope.phoneLogo2x      = require('@amount/frontend-styles/src/images/partners/avant/logo/phone@2x.png')

    # /end Avant card specific assets

    $scope.$emit("customer_application:data", ApplicationService.data)
    angular.extend(
      $scope,
      $controller(
        "CustomerApplicationsMixinCtrl"
        {
          $scope: $scope
          ApplicationService
          CustomerApplicationService
        }
      )
    )

    $scope.trackVisit()
]
